var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItineraryAttractions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4481_15142",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2499 23.25V0.750071H0.75V23.25H23.2499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4481_15142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7043 6.7282H2.58599C1.55053 6.7282 0.703125 7.57552 0.703125 8.61098V21.4141C0.703125 22.4496 1.55053 23.2969 2.58599 23.2969H21.4138C22.4494 23.2969 23.2968 22.4496 23.2968 21.4141V8.61098C23.2968 7.57542 22.4494 6.7282 21.4138 6.7282H20.8881",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2964 2.03262L15.7961 0.702354L15.698 3.53275L13.2959 5.03284L15.698 6.53293L15.7961 9.36328L18.2964 8.03311L20.7965 9.36328L20.8948 6.53293L23.2968 5.03284L20.8948 3.53275L20.7965 0.702354L18.2964 2.03262Z",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.72803 15.7671C6.72803 18.6787 9.08836 21.0391 11.9999 21.0391C14.9116 21.0391 17.2718 18.6787 17.2718 15.7671C17.2718 12.8556 14.9116 10.4953 11.9999 10.4953C9.08836 10.4953 6.72803 12.8556 6.72803 15.7671Z",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.9873 15.7647C8.9873 17.4285 10.3359 18.7773 11.9998 18.7773C13.6635 18.7773 15.0123 17.4285 15.0123 15.7647C15.0123 14.101 13.6635 12.7523 11.9998 12.7523C10.3359 12.7523 8.9873 14.101 8.9873 15.7647Z",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.23456 6.72656H3.71582V4.46715H8.23456V6.72656Z",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.22172 10.1164C5.22172 10.7402 4.7159 11.2461 4.09204 11.2461C3.46823 11.2461 2.9624 10.7402 2.9624 10.1164C2.9624 9.49246 3.46823 8.98668 4.09204 8.98668C4.7159 8.98668 5.22172 9.49246 5.22172 10.1164Z",
    stroke: "#7367F0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItineraryAttractions);
export default __webpack_public_path__ + "static/media/itinerary-attractions.0013619c.svg";
export { ForwardRef as ReactComponent };